import { Outlet, useLoaderData } from 'react-router';
import { Box } from '@mui/material';
import BottomMenu from './BottomMenu';
import { authedApiFetch } from '../utils/Api';
import { useState, useEffect } from 'react';
import useMediaQuery from '../hooks/useMediaQuery';
import { getCurrentUser } from 'utils/currentUser';

import { useNotification } from '../hooks/useNotification';
import Notification from './Notification';

export const rootLoader = async () => {
	const tenants = await authedApiFetch({ endpoint: '/tenants', method: 'GET' });
	const user = await getCurrentUser();

	return { tenants, user };
};

const Root = () => {
	const data = useLoaderData();
	const [_isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
	const isLaptop = useMediaQuery('(max-width: 1200px)');

	// Theme mode pass-through
	const mode = data.themeMode || 'light';
	const onToggleTheme = data.onToggleTheme;

	// Sync with localStorage on mount and when media query changes
	useEffect(() => {
		const savedState = localStorage.getItem('sidebarCollapsed');
		if (savedState !== null) {
			setIsSidebarCollapsed(JSON.parse(savedState));
		} else {
			setIsSidebarCollapsed(isLaptop);
			localStorage.setItem('sidebarCollapsed', JSON.stringify(isLaptop));
		}
	}, [isLaptop]);

	const { notification, showNotification, hideNotification } =
		useNotification();

	return (
		<Box
			sx={{
				display: 'flex',
				flex: 1,
				overflow: 'hidden',
				pb: '74px',
			}}
		>
			<Outlet context={{ showNotification, ...data }} />
			<BottomMenu
				user={data.user}
				tenants={data.tenants}
				mode={mode}
				onToggleTheme={onToggleTheme}
			/>

			<Notification
				notification={notification}
				hideNotification={hideNotification}
			/>
		</Box>
	);
};

export default Root;
